import * as React from "react";
import { Switch, RouteComponentProps, withRouter } from "react-router-dom";
import ChannelsRoute from "../Channels/ChannelsRoute";
import DeploymentProcessRoute from "../Process/Routing/ProcessRoute";
import ReloadableRoute from "components/ReloadableRoute/ReloadableRoute";
import { DeploymentsOverview } from "../DeploymentsOverview";
import { ReleasesRoute } from "../Releases";
import { deploymentLinks } from "./deploymentRouteLinks";
import { ProcessType } from "client/resources";
import DeploymentSettingsRoute from "../DeploymentProcessSettings/Routing/DeploymentSettingsRoute";

type DeploymentsRouteProps = { path: string } & RouteComponentProps;

export class DeploymentsRoute extends React.Component<DeploymentsRouteProps> {
    render() {
        const links = deploymentLinks(this.props.path);
        const match = this.props.match;

        return (
            <ReloadableRoute path={links.root}>
                <Switch>
                    <DeploymentProcessRoute path={`${match.path}/process`} processType={ProcessType.Deployment} />
                    <ChannelsRoute path={`${match.path}/channels`} />
                    <ReloadableRoute path={`${match.path}/releases`} component={ReleasesRoute} />
                    <DeploymentSettingsRoute path={`${match.path}/settings`} />
                    <ReloadableRoute path={`${match.path}`} component={DeploymentsOverview} />
                </Switch>
            </ReloadableRoute>
        );
    }
}

const EnhancedDeploymentsRoute = withRouter(DeploymentsRoute);

export default EnhancedDeploymentsRoute;
